export var RaftConnectionMethod;
(function (RaftConnectionMethod) {
    RaftConnectionMethod["WEB_SOCKET"] = "WebSocket";
    RaftConnectionMethod["WEB_BLE"] = "WebBLE";
    RaftConnectionMethod["PHONE_BLE"] = "PhoneBLE";
})(RaftConnectionMethod || (RaftConnectionMethod = {}));
;
export var RaftTypeE;
(function (RaftTypeE) {
    RaftTypeE["MARTY"] = "Marty";
    RaftTypeE["COG"] = "Cog";
    RaftTypeE["undefined"] = "undefined";
})(RaftTypeE || (RaftTypeE = {}));
;
